module.exports = __webpack_public_path__ + "img/ill borrow this till im dead.8216035d.png";